import { useState } from 'react';
import { Link } from 'react-router-dom';
import { comics, featuredComics } from '@/mocks/comics';

export default function FeaturedGrid() {
  const [hoveredId, setHoveredId] = useState<number | null>(featuredComics[0]);

  const featuredList = featuredComics.map((id) => comics.find((c) => c.id === id)!);

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-primary-500 text-sm font-medium tracking-widest mb-3">
            精选推荐
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            热门韩漫推荐
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-3 max-w-lg mx-auto">
            精选最受欢迎的韩国漫画，下拉式完整版免费阅读，无删减内容尽在韩漫画网
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredList.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group relative rounded-xl overflow-hidden cursor-pointer"
              style={{ aspectRatio: '3/4' }}
              onMouseEnter={() => setHoveredId(comic.id)}
              onMouseLeave={() => setHoveredId(featuredComics[0])}
            >
              <img
                src={comic.cover}
                alt={comic.title}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>

              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <h3 className="text-background-50 font-heading font-bold text-base md:text-lg mb-1">
                  {comic.title}
                </h3>
                <p className="text-background-50/70 text-xs md:text-sm mb-3 line-clamp-2">
                  {comic.author} · {comic.categoryName}
                </p>

                <div
                  className={`overflow-hidden transition-all duration-500 ${
                    hoveredId === comic.id ? 'max-h-24 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="text-background-50/80 text-xs leading-relaxed mb-3">
                    {comic.description}
                  </p>
                  <div className="flex items-center gap-3">
                    <span className="flex items-center gap-1 text-accent-400 text-xs">
                      <i className="ri-star-fill"></i>
                      {comic.rating}
                    </span>
                    <span className="text-background-50/50 text-xs">
                      {comic.views > 10000
                        ? `${(comic.views / 10000).toFixed(0)}万次阅读`
                        : `${comic.views}次阅读`}
                    </span>
                  </div>
                </div>
              </div>

              <div className="absolute top-3 right-3">
                <span className={`px-2 py-1 rounded-full text-[10px] font-medium whitespace-nowrap ${
                  comic.status === '连载中'
                    ? 'bg-accent-500 text-primary-950'
                    : 'bg-secondary-500 text-background-50'
                }`}>
                  {comic.status}
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-8 py-3 bg-foreground-950 hover:bg-foreground-800 text-background-50 font-medium rounded-full text-sm transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            查看全部漫画
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}